import {
  FoodControlBaseData,
  FoodProductionControl,
  FreezingFish,
  OpenBuffet,
  SushiRice,
} from "@enos-monorepo/lib/types/FoodManagementTypes";
import axios from "axios";

import { withFoodControlPointInstance } from "./foodControlPointService";

/*
Heat Reheat
Preservation 
Refrigeratiom
*/

/* Freezing Fish Control - Add & Update */
export const addFreezingFishControl =
  withFoodControlPointInstance<FreezingFish>();
export const updateFreezingFishControl =
  withFoodControlPointInstance<FreezingFish>(true);

/* Open Buffet Control - Add & Update */
export const addOpenBuffetControl = withFoodControlPointInstance<OpenBuffet>();
export const updateOpenBuffetControl =
  withFoodControlPointInstance<OpenBuffet>(true);

/* Sushi Rice Ph Control - Add & Update */
export const addSushiRicePHControl = withFoodControlPointInstance<SushiRice>();
export const updateSushiRicePHControl =
  withFoodControlPointInstance<SushiRice>(true);
export type FermentedVegetableStart = FoodControlBaseData & {
  ph: number;
  saltContent: number;
  storageTemperature: number;
};

export type FermentedVegetableEnd = FoodControlBaseData & {
  ph: number;
};

export type PicklesPhControl = FoodControlBaseData & {
  productName: string;
  ph: number;
};

export const addFoodProductionControl =
  withFoodControlPointInstance<FoodProductionControl>();

export const addFermentedVegetableStart =
  withFoodControlPointInstance<FermentedVegetableStart>();

export const updateFermentedVegetableStart =
  withFoodControlPointInstance<FermentedVegetableStart>(true);

export const addFermentedVegetableEnd =
  withFoodControlPointInstance<FermentedVegetableEnd>();

export const updateFermentedVegetableEnd =
  withFoodControlPointInstance<FermentedVegetableEnd>(true);

export const updateFoodProductionControl =
  withFoodControlPointInstance<FoodProductionControl>(true);

export const addPicklesPhControl =
  withFoodControlPointInstance<PicklesPhControl>();

export const updatePicklesPhControl =
  withFoodControlPointInstance<PicklesPhControl>(true);

export async function getFoodProductionControlByInstanceId(id: string) {
  return axios
    .get("/FoodProductionControls/getfoodproductioncontrolbyinstanceid", {
      params: { id },
    })
    .then(
      (res) =>
        ({
          ...res.data,
          controlPointInstanceId: res.data.foodControlPointInstanceId,
        }) as FoodProductionControl,
    );
}
